import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IQuestionCategories } from '../models/question-categories';

@Injectable({
  providedIn: 'root',
})
export class GetQuestionCategoriesService {
  private http = inject(HttpClient);

  public getQuestionsCategories$(): Observable<IQuestionCategories> {
    return this.http.get<IQuestionCategories>(
      environment.webApiUrl + '/AllQuestionCategories'
    );
  }
}
